import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext, useState, useEffect } from 'react';
import { Button, Heading, Radio, RadioGroup } from '@chakra-ui/react';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import { CheckoutContext } from '../../context/Checkout';
import Address from '../Address/Address';
import { jsx as ___EmotionJSX } from "@emotion/react";
const CheckoutPayment = _ref => {
  let {
    methods,
    nextStep,
    previousStep,
    shippingCountries
  } = _ref;
  const {
    paymentMethod,
    setPaymentMethod,
    shippingMethod,
    setInvoiceAddress,
    shippingAddress
  } = useContext(CheckoutContext);
  const {
    0: filteredMethods,
    1: setFilteredMethods
  } = useState(null);
  const {
    0: customInvoiceAddress,
    1: setCustomInvoiceAddress
  } = useState(false);
  // const [payment, setPayment] = useState(null);

  const onSubmit = async () => {
    if (!customInvoiceAddress) {
      const localShipping = _objectSpread({}, shippingAddress);
      localShipping.address_type = 'invoice';
      await setInvoiceAddress(localShipping);
    }
    if (!paymentMethod) {
      setPaymentMethod(filteredMethods[0].payment_id);
    }
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    nextStep();
  };
  const onChange = value => {
    // setPayment(JSON.parse(value));
    setPaymentMethod(JSON.parse(value));
  };
  const onCustomInvoiceAddressChange = value => {
    const isTrue = value === 'true';
    setCustomInvoiceAddress(!!isTrue);
  };
  const filterMethods = async () => {
    try {
      if (shippingMethod && shippingMethod.id === 1) {
        await setFilteredMethods(methods);
        // await setPaymentMethod(filteredMethods[0].payment_id);
      } else {
        const filtered = await methods.filter(method => method.payment_id.id !== 1);
        await setFilteredMethods(filtered);
        // await setPayment(methods[0].payment_id);
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (methods) {
        filterMethods();
      }
      if (!paymentMethod && filteredMethods) {
        // setPayment(filteredMethods[0])
        setPaymentMethod(filteredMethods[0].payment_id);
      }
    }
    return () => {
      mounted = false;
    };
    //eslint-disable-next-line
  }, [shippingMethod, methods, paymentMethod]);
  return ___EmotionJSX("div", {
    style: {
      maxWidth: '90%',
      margin: 'auto'
    }
  }, ___EmotionJSX(Heading, {
    as: "h2"
  }, "Zahlung"), ___EmotionJSX(Spacer, {
    height: 20
  }), ___EmotionJSX(RadioGroup, {
    value: JSON.stringify(paymentMethod),
    onChange: onChange,
    defaultValue: JSON.stringify(paymentMethod)
  }, filteredMethods && filteredMethods.map(method => {
    return ___EmotionJSX("div", {
      key: method.payment_id.id,
      style: {
        padding: '10px',
        border: '1px solid lightgray',
        marginBottom: '10px',
        borderRadius: '3px'
      }
    }, ___EmotionJSX(Radio, {
      name: "payment_method",
      colorScheme: "brand",
      id: method.payment_id.display_name,
      value: JSON.stringify(method.payment_id)
    }, ___EmotionJSX("span", null, method.payment_id.display_name)));
  })), shippingMethod.id !== 1 && ___EmotionJSX("div", null, ___EmotionJSX(Heading, {
    as: "h2"
  }, "Rechnungsadresse"), ___EmotionJSX(Spacer, {
    height: 20
  }), ___EmotionJSX(RadioGroup, {
    name: "customInvoiceAddress",
    value: customInvoiceAddress.toString(),
    defaultValue: customInvoiceAddress.toString(),
    onChange: onCustomInvoiceAddressChange
  }, ___EmotionJSX("div", {
    style: {
      padding: '10px',
      border: '1px solid lightgray',
      marginBottom: '10px',
      borderRadius: '3px'
    }
  }, ___EmotionJSX(Radio, {
    id: "no-custom-address",
    value: "false",
    colorScheme: "brand"
  }, "Rechnungsadresse identisch mit Lieferadresse")), ___EmotionJSX("div", {
    style: {
      padding: '10px',
      border: '1px solid lightgray',
      marginBottom: '10px',
      borderRadius: '3px'
    }
  }, ___EmotionJSX(Radio, {
    id: "custom-address",
    value: "true",
    colorScheme: "brand"
  }, "Neue Rechnungsadresse eingeben"))), customInvoiceAddress && ___EmotionJSX("div", null, ___EmotionJSX(Address, {
    addressType: "invoice",
    shippingCountries: shippingCountries
  })), ___EmotionJSX(Spacer, {
    height: 20
  })), ___EmotionJSX("div", {
    style: {
      margin: 'auto'
    }
  }, ___EmotionJSX(Button, {
    colorScheme: "brand",
    variant: "solid",
    width: "100%",
    onClick: onSubmit
  }, "Weiter"), ___EmotionJSX(Spacer, {
    height: 20
  }), ___EmotionJSX(Button, {
    colorScheme: "brand",
    variant: "outline",
    width: "100%",
    onClick: previousStep
  }, "Zur\xFCck")));
};
export default CheckoutPayment;